import { createBaseEndpoints, Service } from '../Service'

const ENDPOINTS = createBaseEndpoints('CreditTerms')

class ModuleService extends Service {
  async validateCreate ({ companyID }) {
    const params = {
      filter: `companyID=="${companyID}"`,
      count: true
    }
    const { data: { count, value } } = await this.getAllDynamic(params)
    if (count === 0) {
      return { data: { count, value } }
    } else {
      throw new Error(`not-allow-more-then-one-credit-term`)
    }
  }
}

export const ServiceCreditTerms = new ModuleService({
  ...ENDPOINTS
})
